import { IApiDataState, IState } from "@redux/store.types";
import {
    getApiDataState,
    getApiErrorsStateForKey,
    getApiLoadingState,
} from "@redux/utils";

const isLoading =
    (...keys: Array<keyof IApiDataState>) =>
    (state: IState): boolean => {
        return keys.some(k => !!getApiLoadingState(state, k));
    };

const isSuccessfullyLoaded =
    (...keys: Array<keyof IApiDataState>) =>
    (state: IState): boolean => {
        return keys.some(
            k =>
                !getApiErrorsStateForKey(state, k) &&
                !getApiLoadingState(state, k) &&
                !!getApiDataState(state, k),
        );
    };

export { isLoading, isSuccessfullyLoaded };
